import { cn } from '@/lib/utils'

interface LoadingDotsProps extends React.ComponentPropsWithoutRef<'div'> {
  dotClassName?: string
}

export const LoadingDots = ({ className, dotClassName }: LoadingDotsProps) => {
  return (
    <div
      className={cn(
        'flex h-full w-full items-center justify-center',
        className,
      )}
    >
      <div className="flex animate-pulse space-x-2">
        <div className={cn('size-2 rounded-full bg-gray-500', dotClassName)} />
        <div className={cn('size-2 rounded-full bg-gray-500', dotClassName)} />
        <div className={cn('size-2 rounded-full bg-gray-500', dotClassName)} />
      </div>
    </div>
  )
}
